import appHost from '@/utils/app'
import { usePlatformInfo } from '@/compositions/common'
import { useUserPermissionVerify } from '@/compositions/useUserAuthPermission'

const { judgeIsSrc4Device } = usePlatformInfo()
async function judgeCanUseMiniProgramPay() {
  // 判断能否使用招商支付
  const version = await appHost.getNFAppVersion()
  const isSrc4 = await judgeIsSrc4Device()
  if (isSrc4) {
    return false
  }
  return version !== ''
  // 当前不再使用，默认返回false
  // return false
}
export function useAppPay(): {
  judgeCanUseMiniProgramPay: () => Promise<boolean>
  compatibleWechatAndCmdPay: (payOrderNo: string) => Promise<boolean>
} {
  const { beforeAuthOpenWxMiniProgramHandle } = useUserPermissionVerify()
  async function compatibleWechatAndCmdPay(payOrderNo: string): Promise<boolean> {
    // 调用时会判断当前app是否支持招商支付, 如果可以就会调起极飞服务小程序进行支付，旧版本不支持得情况调用微信原生
    // 不需要支持招商支付的业务不可使用这个方法
    const canUseCmbPay = await judgeCanUseMiniProgramPay()
    if (canUseCmbPay) {
      // 0正式版 1测试版  2体验版
      const userAgree = await beforeAuthOpenWxMiniProgramHandle({
        id: 'gh_68b32d3107f6',
        path: '/pages/user/pay?guid=' + payOrderNo,
        version: process.env.NODE_ENV === 'production' ? 0 : 1,
      })
      if (!userAgree) {
        return false
      }
    } else {
      appHost.onPay(payOrderNo)
    }
    return true
  }
  return {
    judgeCanUseMiniProgramPay,
    compatibleWechatAndCmdPay,
  }
}
